import React from "react";
import { Field, FieldArray } from "formik";
import moment from "moment";
import { Input, Select, DatePicker } from "../../../../../components/formik";
import { optionsType } from "../../../../../prop-types";
import { Col, Row } from "reactstrap";
import { withError } from "../../../../../components/hocs";

const ErrorInput = withError(Input);

const NaturalPersonFormFields = ({ nationalities, countries }) => (
  <React.Fragment>
    <Row className="mt-4">
      <Col lg={5}>
        <Field
          placeholder="First name"
          name="name.firstName"
          component={ErrorInput}
        />
      </Col>
      <Col lg={7} className="p-0">
        <Row>
          <Col lg={6} className="pr-0">
            <Field
              dateFormat="dd.MM.yyyy"
              placeholderText="Date of birth (dd.mm.yyyy)"
              changeOnInput={true}
              name="birthDate"
              component={DatePicker}
              maxDate={new Date(moment())}
              minDate={new Date().setFullYear(1900)}
              yearDropdownItemNumber={150}
            />
          </Col>
          <Col lg={6}>
            <FieldArray name="identifications">
              <Field
                placeholder="Identification number"
                name="identifications[0].number"
                component={Input}
              />
            </FieldArray>
          </Col>
        </Row>
      </Col>
    </Row>
    <Row className="mt-4">
      <Col lg={5}>
        <Field
          placeholder="Middle name"
          name="name.middleName"
          component={Input}
        />
      </Col>
      <Col lg={7} className="p-0">
        <Row>
          <Col lg={6} className="pr-0">
            <Field
              placeholder="City"
              name="addresses[0].city"
              component={Input}
            />
          </Col>
          <Col lg={6}>
            <Field
              placeholder="Post code"
              name="addresses[0].postalCode"
              component={Input}
            />
          </Col>
        </Row>
      </Col>
    </Row>

    <Row className="mt-4">
      <Col lg={5}>
        <Field
          placeholder="Last name"
          name="name.lastName"
          component={ErrorInput}
        />
      </Col>
      <Col lg={7}>
        <Field
          placeholder="Street and number"
          name="addresses[0].streetNumber"
          component={Input}
        />
      </Col>
    </Row>

    <Row className="mt-4">
      <Col lg={5}>
        <Field
          placeholder="Nationality"
          className="dropdown-group"
          name="nationalityId"
          component={Select}
          options={nationalities}
        />
      </Col>
      <Col lg={7}>
        <FieldArray name="addresses">
          <Field
            placeholder="Address of residence"
            name="addresses[0].addressOfResidence"
            component={Input}
          />
        </FieldArray>
      </Col>
    </Row>
    <Row className="mt-4">
      <Col lg={12}>
        <Field
          type="textarea"
          placeholder="Comment"
          name="comment"
          component={ErrorInput}
        />
      </Col>
    </Row>
  </React.Fragment>
);

NaturalPersonFormFields.propTypes = {
  nationalities: optionsType.isRequired,
};

export default NaturalPersonFormFields;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry-eu-terrorists/components/upsert-watch-list-entry-form/natural-person-form-fields/NaturalPersonFormFields.jsx